var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuntosInteres(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Beneficios",
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.066,
    height: 272.219,
    viewBox: "0 0 186.066 272.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #554586;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M147.543,212.015a128.691,128.691,0,0,0-21.233-5.406c4.965-5.831,10.257-12.3,15.571-19.208,29.323-38.111,44.187-69.868,44.187-94.362A93.034,93.034,0,1,0,0,93.034c0,24.636,14.869,56.431,44.187,94.493,5.292,6.871,10.557,13.3,15.506,19.093a128.712,128.712,0,0,0-21.168,5.4C16.4,219.92,11.76,230.526,11.76,238.05s4.644,18.13,26.765,26.03c14.7,5.248,34.044,8.139,54.509,8.139s39.809-2.891,54.509-8.139c22.121-7.9,26.765-18.511,26.765-26.03S169.669,219.92,147.543,212.015ZM15.952,93.034a77.084,77.084,0,0,1,154.169,0c0,20.574-14.1,49.789-40.762,84.491a520.178,520.178,0,0,1-36.336,42.1,515.951,515.951,0,0,1-36.2-41.829C30.086,143.084,15.952,113.788,15.952,93.034ZM142.186,249.059c-13.007,4.65-30.489,7.208-49.152,7.208s-36.14-2.559-49.146-7.208C32.122,244.85,27.712,240.1,27.712,238.05s4.41-6.8,16.175-11.019a127.245,127.245,0,0,1,28.463-6.1c8.662,9.457,14.656,15.32,15.119,15.789l5.58,5.444,5.564-5.444c.463-.452,6.43-6.315,15.065-15.789a127.276,127.276,0,0,1,28.507,6.109c11.782,4.214,16.175,8.989,16.175,11.014S153.967,244.85,142.186,249.059Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M191.394,121.813a6.388,6.388,0,0,0-12.137,3.916,39.6,39.6,0,1,1-27.02-25.972,6.389,6.389,0,1,0,3.43-12.309,52.379,52.379,0,1,0,35.771,34.366Z",
    transform: "translate(-48.406 -42.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M222.141,108.682l-.057-.058a6.388,6.388,0,0,0-9.007,9.033l.058.057a6.387,6.387,0,1,0,9.033-9.033Z",
    transform: "translate(-97.548 -49.161)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosInteres);
export default __webpack_public_path__ + "static/media/Puntos-interes.24d660a5d3e36716dbd6041bfcf502a8.svg";
export { ForwardRef as ReactComponent };